import { State } from '..';

interface EventProps {}

const StateFinish = function <S, P, A, R>() {
  return {
    onEnter: () => {
      return { type: 'FINISH' };
    },

    nodeName: 'T.states.finish',
    outputs: null,
  } as State<S, P, A, R>;
};

export default StateFinish;
